import React from "react";
import { MapPin, Camera, ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function TheLoneExplorersView() {
  return <section data-section-id="2858" id="the-essence-of-our-vineyard" className="dark relative h-screen w-full overflow-hidden bg-background text-foreground">
      {}
      <style>{`
        @keyframes subtleZoom {
          0% { transform: scale(1); }
          100% { transform: scale(1.1); }
        }
        @keyframes scrollLine {
          0% { transform: translateY(0); opacity: 1; }
          100% { transform: translateY(100%); opacity: 0; }
        }
        .animate-subtle-zoom {
          animation: subtleZoom 20s ease-in-out infinite alternate;
        }
        .animate-scroll-line {
          animation: scrollLine 2s cubic-bezier(0.77, 0, 0.175, 1) infinite;
        }
      `}</style>

      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600482/img/misty_mountains_hero.png" alt="Sun-drenched vineyard at dawn" className="h-full w-full object-cover animate-subtle-zoom opacity-70" />
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-transparent to-black/80" />
        <div className="absolute inset-0 bg-primary/20 mix-blend-multiply" />
      </div>

      {}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center">
        {}
        <h1 className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-medium uppercase tracking-tighter text-white drop-shadow-2xl">The 2026 Vintage<br />Has Arrived</h1>

        {}
        <div className="mt-8 mb-10 flex flex-wrap items-center justify-center gap-4 rounded-sm border border-white/10 bg-black/30 px-6 py-2 text-xs font-medium tracking-widest text-white/90 backdrop-blur-md md:text-sm">
          <div className="flex items-center gap-2">
            <MapPin className="h-3 w-3 md:h-4 md:w-4 text-secondary" />
            <span className="font-mono">38.5025° N, 122.2654° W</span>
          </div>
          <div className="h-3 w-px bg-white/20" />
          <div className="flex items-center gap-2">
            <Camera className="h-3 w-3 md:h-4 md:w-4 text-secondary" />
            <span className="font-mono">EST. 1984 • NAPA VALLEY</span>
          </div>
        </div>

        {}
        <Link to="/ShopPage">
          <Button size="lg" className="group relative overflow-hidden border-none bg-white text-primary transition-all duration-500 hover:scale-105 hover:text-white">
            <span className="relative z-10 font-serif tracking-wide">Explore the Collection</span>
            <div className="absolute inset-0 -z-0 translate-y-full bg-secondary transition-transform duration-500 group-hover:translate-y-0" />
          </Button>
        </Link>
      </div>

      {}
      <div className="absolute bottom-10 left-1/2 z-10 -translate-x-1/2 flex flex-col items-center gap-2">
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/60">
          Scroll
        </span>
        <div className="h-12 w-px overflow-hidden bg-white/20">
          <div className="h-full w-full bg-secondary animate-scroll-line" />
        </div>
      </div>
    </section>;
}